import { z } from 'zod/v4-mini';
import { mutationProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
import type { GetDataInput } from './getData.js';

interface PublishDataInput extends GetDataInput {
  /** Data to publish */
  data: unknown;
}

const ZodPublishDataInput = matchingZodObject<PublishDataInput>({
  path: z.array(z.string()),
  data: z.unknown(),
});

/**
 * Allows clients to publish data to the bus
 */
export function publishData(params: ApiParams<PublishDataInput, 'bus'>): void {
  const {
    input: { path, data },
    ctx: { bus },
  } = params;

  bus.publish(path, data);
}

// Attach a trpc procedure to the function.
publishData.procedure = mutationProcedure<PublishDataInput, void>(publishData, ZodPublishDataInput, z.void());
